import React from 'react'
import { inject, observer } from "mobx-react"
import PropTypes from 'prop-types'

@inject("store")
@observer
export default class Visibility extends React.Component {
  render() {
    const { store, showOnPrint, hideOnPrint, children } = this.props
    const { printVersion } = store

    if(showOnPrint) {
      if(printVersion) {
        return <div>{this.props.children}</div>
      }
      else {
        return null
      }
    }
    else if(hideOnPrint) {
      if(printVersion) {
        return null
      }
      else {
        return <div>{ children }</div>
      }
    }
  }
}
